"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
/* eslint-disable no-underscore-dangle */
var loader_1 = require("./loader");
var TokenService_1 = __importDefault(require("../../shared/src/services/TokenService"));
var MessageBusService_1 = __importDefault(require("../../shared/src/services/MessageBusService"));
__exportStar(require("./loader"), exports);
__exportStar(require("../../shared/src"), exports);
__exportStar(require("./reactLoader"), exports);
var init = function (apps, history, sharedDependencies, authorization) {
    var _a;
    window.__mf = __assign(__assign({ apps: {}, shared: {}, configs: {} }, window.__mf), { services: __assign({ TokenService: new TokenService_1.default(authorization), MessageBusService: new MessageBusService_1.default() }, (_a = window.__mf) === null || _a === void 0 ? void 0 : _a.services), history: history !== undefined || window.__mf === undefined
            ? history
            : window.__mf.history });
    sharedDependencies === null || sharedDependencies === void 0 ? void 0 : sharedDependencies.forEach(function (_a) {
        var name = _a.name, value = _a.value;
        window[name] = value;
    });
    apps === null || apps === void 0 ? void 0 : apps.forEach(function (app) {
        (0, loader_1.load)(app);
    });
};
exports.init = init;
